var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3H3C1.89543 3 1 3.89543 1 5V14C1 15.1046 1.89543 16 3 16H16V5C16 3.89543 15.1046 3 14 3Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.00049H19.1716C19.702 8.00049 20.2107 8.2112 20.5858 8.58627L22.4142 10.4147C22.7893 10.7898 23 11.2985 23 11.8289V14.0005C23 15.1051 22.1046 16.0005 21 16.0005H16V8.00049Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49921 20.9995C6.87992 20.9995 7.99921 19.8802 7.99921 18.4995C7.99921 17.1188 6.87992 15.9995 5.49921 15.9995C4.11849 15.9995 2.99921 17.1188 2.99921 18.4995C2.99921 19.8802 4.11849 20.9995 5.49921 20.9995Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.9995C19.8807 20.9995 21 19.8802 21 18.4995C21 17.1188 19.8807 15.9995 18.5 15.9995C17.1193 15.9995 16 17.1188 16 18.4995C16 19.8802 17.1193 20.9995 18.5 20.9995Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierApproval);
export default __webpack_public_path__ + "static/media/supplierApproval.d3e5a35064fecbb3c82d11fe5d0f5cef.svg";
export { ForwardRef as ReactComponent };